<template>
  <div>
    <div style="max-width: 86%">
      <v-alert
        text
        type="error"
        icon="mdi-cloud-alert"
        :value="ciemException.error != null"
      >
        {{ ciemException.error }}
      </v-alert>
      <v-alert
        text
        outlined
        color="deep-orange"
        icon="mdi-fire"
        :value="ciemException.warning != null"
      >
        {{ ciemException.warning }}
      </v-alert>
      <v-alert
        text
        dense
        color="teal"
        icon="mdi-clock-fast"
        border="left"
        :value="ciemException.success != null"
      >
        {{ ciemException.success }}
      </v-alert>
    </div>
    <crud-detail
      :update-mode="updateMode"
      :showButton="false"
      class="mt-2"
      :next="next"
      :modalLeave="modalLeave"
      @closeLeave="modalLeave = false"
    >
      <headers-detail>
        <v-flex>
          <v-btn
            v-if="form.allowedToAccept == true"
            color="green"
            class="px-3 white--text custom-radiation"
            @click="accepterPopup = true"
          >
            {{ $t('mutation.accepter.action') }}
          </v-btn>
        </v-flex>
        <v-flex>
          <v-btn
            color="pink"
            class="px-3 white--text custom-radiation"
            @click="annulerPopup = true"
          >
            {{ $t('mutation.annuler.action') }}
          </v-btn>
        </v-flex>
      </headers-detail>
      <v-layout row class="specific">
        <v-flex md2 mb-5 v-if="form.enCours == true">
          <v-chip color="green" text-color="white">
            {{ $t('mutation.encours') }}
          </v-chip>
        </v-flex>
      </v-layout>

      <v-layout row :class="'pr-2 pl-2 pt-3'">
        <!-- informations participant (gauche) -->

        <v-flex md11>
          <v-layout row>
            <v-flex md3>
              <v-text-field
                :value="
                  form.participant.name + ' ( ' + form.participant.id + ' )'
                "
                :label="$t('mutation.participant')"
                readonly
                disabled
              />
            </v-flex>
            <v-flex md1 />
            <v-flex md3>
              <v-text-field
                :value="form.auteurMouvement"
                :label="$t('mutation.auteurMouvement')"
                readonly
                disabled
              />
            </v-flex>
            <v-flex md1 />
            <v-flex md2>
              <v-text-field
                :value="form.date"
                :label="$t('mutation.date')"
                readonly
                disabled
              />
            </v-flex>
          </v-layout>
          <v-layout row mt-5>
            <v-flex md3>
              <v-text-field
                :value="form.typeMouvement"
                :label="$t('mutation.typeMouvement')"
                readonly
                disabled
              />
            </v-flex>
            <v-flex md1 />
            <v-flex md3>
              <v-text-field
                :value="form.motifMouvement"
                :label="$t('mutation.motifMouvement')"
                readonly
                disabled
              />
            </v-flex>
          </v-layout>
          <v-layout row mt-5>
            <v-flex md3>
              <v-text-field
                :label="$t('mutation.etablissementSource')"
                :value="
                  form.etablissementSource.raisonSociale +
                  '( ' +
                  form.etablissementSource.id +
                  ' )'
                "
                readonly
                class="red--text"
              ></v-text-field>
            </v-flex>
            <v-flex md1 />
            <v-flex md3>
              <v-text-field
                :label="$t('mutation.etablissementDestination')"
                :value="
                  form.etablissementDestination.raisonSociale +
                  '( ' +
                  form.etablissementDestination.id +
                  ' )'
                "
                readonly
                class="red--text"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </crud-detail>

    <c-dialog
      persistent
      :dialog="accepterPopup"
      max-width="40%"
      @close="accepterPopup = false"
    >
      <v-card-title class="headline primary white--text" dark primary-title>
        {{ $t('mutation.accepter.title') }}
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md>
          <v-layout row>
            <v-flex md11>
              <v-card class="specific mx-auto" color="">
                <v-card-title class="" style="justify-content: center">
                  <p v-html="$t('mutation.accepter.message')"></p>
                </v-card-title>
              </v-card>
            </v-flex>
          </v-layout>

          <v-layout
            row
            mb-5
            v-if="
              form.participant.bilanEnCours == true &&
              form.demandePriseEnChargeBilan == true
            "
          >
            <v-flex md11>
              <v-card class="specific mx-auto" color="primary" dark>
                <v-card-title
                  class="pink white--text"
                  style="justify-content: center"
                >
                  <p
                    v-html="$t('mutation.accepter.priseEnChargeBilanEnCours')"
                  ></p>
                </v-card-title>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn @click="annulerOuAccepterMutation(false)" dark color="green">{{
          $t('mutation.accepter.action')
        }}</v-btn>
        <v-btn @click="accepterPopup = false">{{ $t('button.cancel') }}</v-btn>
      </v-card-actions>
    </c-dialog>
    <c-dialog
      persistent
      :dialog="annulerPopup"
      max-width="50%"
      @close="annulerPopup = false"
    >
      <v-card>
        <v-card-title class="headline primary white--text" dark primary-title>
          {{ $t('mutation.annuler.title') }}
        </v-card-title>

        <div row class="ma-2 pa-5">
          <v-layout row mb-5>
            <v-flex md11>
              <p>{{ $t('mutation.annuler.message') }}</p>
            </v-flex>
          </v-layout>
        </div>

        <v-divider />

        <v-card-actions>
          <v-btn @click="annulerOuAccepterMutation(true)" dark color="pink">{{
            $t('mutation.annuler.action')
          }}</v-btn>
          <v-btn @click="annulerPopup = false">{{ $t('button.cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </c-dialog>
  </div>
</template>

<script>
import DetailCrud from '@/plugins/DetailCrud'
import eagerLoading from '@/utils/eager'
import { alert } from '@/commun/alertMessage'
import _ from 'lodash'
import toasted from '@/utils/toasted'

const NAMESPACE = 'mutation'

export default {
  beforeRouteEnter: eagerLoading(NAMESPACE),
  mixins: [DetailCrud],
  provide() {
    return {
      namespace: NAMESPACE,
      $vroot: this.$v,
    }
  },
  data() {
    return {
      namespace: NAMESPACE,
      saving: false,
      annulerPopup: false,
      accepterPopup: false,
      ciemException: alert,
      form: {
        contact: {},
        etablissementSource: {},
        etablissementDestination: {},
        participant: {},
      },
    }
  },
  created() {},
  mounted() {},
  computed: {},
  beforeDestroy() {
    this.resetAlert()
  },
  watch: {},
  methods: {
    initForm(loaded) {
      this.form = loaded
    },
    annulerOuAccepterMutation(annuler) {
      this.resetAlert()

      let uri = ''
      if (annuler == true) {
        uri = '/annuler'
      } else {
        uri = '/accepter'
      }
      const api = this.$api(
        this.updateURI + '/' + this.form.participant.id + uri,
      )
      return api
        .post()
        .then(
          (response) => {
            if (
              response &&
              response.body &&
              !_.isEmpty(response.body.messages)
            ) {
              response.body.messages.forEach((m) => {
                if (m.level == 'ERROR') {
                  this.ciemException.error = this.$t(m.errorCode)
                } else if (m.level == 'WARN') {
                  this.ciemException.warning = this.$t(m.errorCode)
                } else if (m.level == 'INFO') {
                  this.ciemException.success = this.$t(m.errorCode)
                }
              })
            }
            //this.ciemException = response;
            this.refreshViewMutation()
            this.$router.go(-1)
          },
          () => {
            //todo
          },
        )
        .catch(() => {
          // TODO gestion du cas d'erreur not found
        })
        .finally(() => {
          this.annulerPopup = false
        })
    },
    refreshViewMutation() {
      this.$api(this.updateURI)
        .get()
        .then((response) => {
          this.initForm(response.body)
          this.setInitialFormDigest()
          toasted.info('form.reloaded')
        })
        .catch(() => {
          // TODO gestion du cas d'erreur not found
        })
    },
    resetAlert() {
      this.ciemException.error = null
      this.ciemException.warning = null
      this.ciemException.success = null
    },
  },
  validations: {},
}
</script>

<style scoped>
.custom-save {
  border-radius: 5px;
}

.custom-delete {
  border-radius: 5px;
}

.custom-message {
  background-color: var(--v-primary-base);
}

.v-subheader {
  background-color: var(--v-updatedGrey-base);
  color: white !important;
  border-radius: 5px;
  font-size: 13px;
}

.subheaderSpecificColor .v-subheader {
  background-color: var(--v-rose-base) !important;
}

.v-subheader .v-icon {
  color: white;
}

.custom-yellow-badge >>> .v-badge__badge {
  background-color: var(--v-yellow-base) !important;
}
</style>
<style>
.specific table.v-table tbody td {
  font-size: 11px;
}

.specific .material-icons {
  font-size: 18px;
}
.specificTableau .v-messages {
  display: none;
}

.specificTableau .v-input__slot {
  margin-bottom: 0px !important;
}

.specific .v-system-bar--window {
  height: 23px !important;
}

.specific .v-subheader {
  height: 23px !important;
}

.specificCloseBtn .v-btn--floating.v-btn--small {
  height: 33px !important;
  min-width: 0;
  padding: 0;
  width: 33px !important;
}
.specific .v-chip .v-chip__content {
  height: 26px;
}
.smallChip .v-chip {
  font-size: 10px !important;
  height: 20px;
}
.smallChip .v-chip .v-avatar {
  height: 20px !important;
  min-width: 20px;
  width: 20px !important;
}

.specific .v-avatar {
  height: 28px !important;
  width: 28px !important;
}

.reduceDialogClass {
  top: 4.10417px !important;
  position: fixed !important;
  margin: 0px !important;
  transition: none 0s ease 0s !important;
}
</style>
